import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ArrowLeft } from '@components/Common/Icons';
import { Cross, ArrowLeft3 } from '@lion-design/icons';
import styles from '../styles.module.scss';
import cN from 'classnames';

interface I_SlidePage {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
    title: string;
    children: JSX.Element;
    isHeaderShow?: boolean;
    side?: string;
}

const ContentBlock: React.FC<I_SlidePage> = ({
    visible,
    children,
    title,
    setIsVisible,
    isHeaderShow = true,
    side,
}) => {
    return (
        <>
            <div
                className={cN(
                    styles[side === 'bottom' ? 'sidebarMask' : ''],
                    styles[visible ? 'open' : '']
                )}
                onClick={() => setIsVisible(false)}
            />
            <div
                className={cN(
                    styles.slidePage,
                    styles[side === 'bottom' ? 'bottom' : ''],
                    styles[visible ? 'open' : '']
                )}
            >
                {isHeaderShow && (
                    <div className={styles.header}>
                        <div className={styles.goBack} onClick={() => setIsVisible(false)}>
                            {side === 'bottom' ? (
                                <Cross width={32} height={32} fill="#444" />
                            ) : (
                                <ArrowLeft3 width={32} height={32} fill="#f03742" />
                            )}
                        </div>
                        <div className={styles.title}>{title}</div>
                    </div>
                )}
                <div className={cN(styles.content, 'contentBox')}>{children}</div>
            </div>
        </>
    );
};

export default ContentBlock;
